// extracted by mini-css-extract-plugin
module.exports = {"component":"LunchPage_component__1Qm9y","header":"LunchPage_header__1wV92","main":"LunchPage_main__2zG75"};